<template>
    <div id="app">
        <div id="wrapper">
            <transition name="fade" @after-leave="afterLeave">
                <router-view :key="$route.fullPath" />
            </transition>
        </div>
    </div>
</template>

<script>
    import resize from './mixins/resize'

    export default {
        name: 'app',
        mixins: [resize],
        methods: {
            afterLeave: function() {
                this.resizeContent();
            }
        }
    }
</script>

<style lang="scss">
    @import '../node_modules/bootstrap/scss/bootstrap.scss';
    @import './scss/main';
    @import './scss/base/transitions';
</style>
